var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3099_37204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.86 31.84C6.26 30.48 0.5 23.92 0.5 16C0.5 7.2 7.7 0 16.5 0C25.3 0 32.5 7.2 32.5 16C32.5 23.92 26.74 30.48 19.14 31.84L18.26 31.12H14.74L13.86 31.84Z",
    fill: "#0062E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7399 20.48L23.4599 16H19.2199V12.88C19.2199 11.6 19.6999 10.64 21.6199 10.64H23.6999V6.55999C22.5799 6.39999 21.2999 6.23999 20.1799 6.23999C16.4999 6.23999 13.9399 8.47999 13.9399 12.48V16H9.93994V20.48H13.9399V31.76C14.8199 31.92 15.6999 32 16.5799 32C17.4599 32 18.3399 31.92 19.2199 31.76V20.48H22.7399Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3099_37204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebookLogo.a0a7d665a5b2e76e01972edc96c8472b.svg";
export { ForwardRef as ReactComponent };